import { Box, Paper, Stack, Typography } from "@mui/material";
import type { ChatMessage } from "../types";

export type ChatTranscriptProps = {
  messages: ChatMessage[];
};

export const ChatTranscript = ({ messages }: ChatTranscriptProps) => {
  if (messages.length === 0) {
    return (
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.secondary",
          px: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="body2">
          Ask anything, or attach an image and ask Gemma 4 to describe or
          extract information from it. The model loads on first send.
        </Typography>
      </Box>
    );
  }
  return (
    <Stack spacing={1.5} sx={{ flexGrow: 1, overflowY: "auto", p: 1 }}>
      {messages.map((msg) => {
        const isUser = msg.role === "user";
        return (
          <Stack
            key={msg.id}
            direction="row"
            sx={{ justifyContent: isUser ? "flex-end" : "flex-start" }}
          >
            <Paper
              variant="outlined"
              sx={{
                p: 1.25,
                maxWidth: "85%",
                bgcolor: isUser ? "primary.main" : "background.paper",
                color: isUser ? "primary.contrastText" : "text.primary",
                borderColor: isUser ? "primary.main" : "divider",
              }}
            >
              {msg.imageUrl && (
                <Box
                  component="img"
                  src={msg.imageUrl}
                  alt="attached"
                  sx={{
                    display: "block",
                    maxWidth: "100%",
                    maxHeight: 240,
                    borderRadius: 1,
                    mb: msg.text ? 1 : 0,
                  }}
                />
              )}
              {msg.text && (
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                >
                  {msg.text}
                </Typography>
              )}
            </Paper>
          </Stack>
        );
      })}
    </Stack>
  );
};
